export default class AplCodeGenerator {
	constructor() {
		this.init();
	}

	init() {
		document.querySelectorAll('input[type="text"][data-provide="aplCodeGenerator"]:not([data-acg-init="1"])').forEach(function (item, key) {
			item.setAttribute('data-acg-init', "1");
			let input = document.getElementById(item.getAttribute('data-acg-input-id'));

			item.addEventListener('keyup', (e) => {
				input.value = txtToAplKod(item.value);
			});
		});
	}
}
